import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CombinedResultsPage } from './combined-results';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [
    CombinedResultsPage,
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(CombinedResultsPage),
  ],
})
export class CombinedResultsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/combined-results/combined-results.module.ts